import { SET_PAYMENT_METHODS, REQUEST_CHANGE_PAYMENT_METHOD } from '../actions/paymentMethods';

export default function paymentMethods(state = { sources: [], isLoading: false }, { type, payload }) {
    switch (type) {
        case REQUEST_CHANGE_PAYMENT_METHOD:
            return {
                ...state,
                isLoading: true
            };
        case SET_PAYMENT_METHODS:
            return {
                data: [...payload],
                isLoading: false
            };
        default:
            return state;
    }
}
